import log, { getLogger, LogLevelDesc } from 'loglevel';
import remote from 'loglevel-plugin-remote';
import { useCallback, useContext, useState } from 'react';
import { Profile } from '../models/profile-interface';
import { CSPORTAL_APPLICATION_ID } from './api';
import { AuthContext } from './auth';

const CustomJSON = (log) => {
  // Depending on if the function that calls the logger is a functional component or not
  // Will need to change the payload to either include the profile information or not.
  try {
    const profile = JSON.parse(localStorage.getItem('currentUser'));
    return ({
      message: log.message,
      level: log.level.label,
      stacktrace: log.stacktrace,
      userId: profile?.userId ?? null,
      companyId: profile?.companyId ?? null,
      applicationId: CSPORTAL_APPLICATION_ID
    });
  } catch {
    return ({
      message: log.message,
      level: log.level.label,
      stacktrace: log.stacktrace,
      userId: null,
      companyId: null,
      applicationId: CSPORTAL_APPLICATION_ID
    });
  }
};

remote.apply(log, { 
  method: 'POST', 
  format: CustomJSON, 
  url: '/api/error/log', 
  headers: {'api-version': '2.0', 'Access-Control-Allow-Origin': '*'},
  level: process.env.REACT_APP_ERROR_LEVEL ?? "trace",
});

export const Logger = () => {
  var logger = getLogger('Root');

  const errorLevel: LogLevelDesc = process.env.REACT_APP_ERROR_LEVEL ?? "trace";

  log.setDefaultLevel(errorLevel);
  logger.setDefaultLevel(errorLevel);
  logger.setLevel(errorLevel, true);

  return logger;
};